/**
 * Dirección de la app de asambleas en vivo (`asambleas/`, Asambleas v2).
 * Hasta el corte (docs/CORTE_ASAMBLEAS.md) vive en la URL de Render; el día
 * del corte pasa a https://asambleas.innovaclarke.cl. La onrender sigue
 * respondiendo después, así que el link nunca queda roto.
 */
export const ASAMBLEAS_APP_URL = "https://asambleas.innovaclarke.cl";
